var MinicartLogin = class extends HTMLElement {
    triggerButtons = this.querySelectorAll('button[data-action="switch-form"]')
    loginFormElement = this.querySelector('#login-form-container')
    recoverFormElement = this.querySelector('#recover-form-container')
    emptyCartEl = this.querySelector('#empty-cart-container')

    connectedCallback() {
        this.triggerButtons.forEach((button) => {
            button.addEventListener('click', (e) => this.switchForm(e));
        });
    }



    switchForm(e) {
        e.preventDefault()
        const target = e.currentTarget;

        if (target.id == 'password-container-toggler') {
            this.emptyCartEl.classList.remove('visible')
            this.loginFormElement.classList.remove('visible')
            this.recoverFormElement.classList.add('visible')

        } else {
            this.recoverFormElement.classList.remove('visible')
            this.emptyCartEl.classList.remove('visible')
            this.loginFormElement.classList.add('visible')
        }
    }

    formSubmitHandler(e) {
        if (this.registerForm.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            for (const el of this.registerForm.querySelectorAll("[required]")) {
                if (!el.reportValidity()) {
                    console.log(!el.reportValidity());
                    return;
                }
            }
        } else {
            if(this.klaviyoCheck.checked) {
                e.preventDefault();

                $('#klaviyo_register_id_email').val($('#register-customer .email-input-field').val())

                const formData = new FormData(this.klaviyoForm);
                const url = this.klaviyoForm.action;
                console.log(url);
                console.log(formData);

                fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // Change content type to URL encoded form data
                    },
                    body: new URLSearchParams(formData), // Convert the serialized data to URLSearchParams format
                })
                    .then((response) => response.json())
                    .then((data) => {
                        console.log(data);
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                    });

                this.registerForm.submit();
            }
        }
    }

};
window.customElements.define("minicart-login", MinicartLogin);
